module.exports = __webpack_public_path__ + "static/img/wx-tips.a44cee11.png";